import { createEvent } from '../../shared/utils/tracking.utils';

export const loadReportEvent = createEvent<{
  area: string;
  location: string;
  date: string;
  period: string;
}>('Loaded Report');

export const openAnonymousReportEvent = createEvent<{
  username: string;
}>('Opened Anonymous Report');

export const goToImagesEvent = createEvent<{
  category: 'at risk' | 'lost' | 'compliant';
}>('Scrolled To Images');

export const goToAtRiskCharts = createEvent('Go To At Risk Charts');
